import { useField } from 'formik';

interface CustomCheckboxInputProps {
  name: string;
  placeholder?: string;
  label: string;
  divClass: string;
  labelClass: string;
  inputClass: string;
  value?: boolean;
}

const CustomCheckboxInput: React.FC<CustomCheckboxInputProps> = ({
  label,
  divClass,
  labelClass,
  inputClass,
  value,
  ...props
}: CustomCheckboxInputProps) => {
  const [field, meta] = useField(props);

  const isError = Boolean(meta.touched && meta.error);

  const inputClassWithError = isError ? inputClass + ' border-red-600 border-[1px]' : inputClass;

  return (
    <div className={divClass}>
      <label className={labelClass}>{label}</label>
      <div className="flex flex-col">
        <input
          data-cy={`${props.name}-checkbox`}
          type="checkbox"
          {...field}
          className={inputClassWithError}
          {...props}
          checked={value}
        />
        {isError && <div className="text-xs text-red-600 text-left">{meta.error}</div>}
      </div>
    </div>
  );
};

export default CustomCheckboxInput;
